import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useCopy, useLang } from "@/contexts/LanguageContext";

const COPY = {
  en: { h: "Users", cols: ["Name", "Email", "Role", "Active", "Created"], yes: "Yes", no: "No" },
  hi: { h: "उपयोगकर्ता", cols: ["नाम", "ईमेल", "भूमिका", "सक्रिय", "बनाया गया"], yes: "हाँ", no: "नहीं" },
};

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const c = useCopy(COPY);
  const { t } = useLang();
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="admin-users">
      <div><h1 className="text-3xl font-bold text-slate-900 brand-heading">{c.h}</h1></div>
      <div className="overflow-x-auto table-scroll rounded-lg border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200 bg-slate-50">
            <tr>{c.cols.map((h) => <th key={h} className="py-3 px-4">{h}</th>)}</tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-slate-100" data-testid={`user-row-${u.id}`}>
                <td className="py-3 px-4 font-medium">{u.name}</td>
                <td className="py-3 px-4">{u.email}</td>
                <td className="py-3 px-4"><span className="rounded-full bg-slate-100 border border-slate-200 text-xs px-2 py-0.5">{t(`role_${u.role}`)}</span></td>
                <td className="py-3 px-4">{u.active ? c.yes : c.no}</td>
                <td className="py-3 px-4 text-slate-500">{u.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
